import { Field, FieldProps, Formik, FormikProps } from 'formik';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
    date as dateYup,
    object as objectYup,
    string as stringYup,
    number as numYup,
    boolean as booleanYup,
} from 'yup';
import getValue from 'lodash/get';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { CandidateFormData, CandidateRequestType, GenderEnum, SocialEnum } from '../../../types/auth';
import useInitialErrors from '../../../hooks/formik-initial-errors';
import { authService } from '../../../lib/api/auth';
import { deleteReduxProfile } from '../../../redux/registration';
import { goToRoom } from './../utils';
import { routes } from '../../routes/routes-names';
import ReCAPTCHA from 'react-google-recaptcha';
import { getSiteKey, isConsentFeatureEnabled, isKYCDigioSignFeatureEnabled } from '../../../lib/utils/common-functions';
import { getConsentWorkflowSettings } from '../../../redux/consentWorkFlow';
import DatePickerComponent from '../../../components/date-picker';
import PhoneCodeDropdown from '../../../components/dropdown/phoneCode';
import StateDropdown from '../../../components/dropdown/states';
import CountryDropdown from '../../../components/dropdown/country';
import CityDropdown from '../../../components/dropdown/city';
// import moment from 'moment';
import secureLocalStorage from 'react-secure-storage';
import {
    ALLOWED_COUNTRIES,
    isCaptchaEnabled,
    USER_DATA_CACHE_KEY,
    USER_DATA_IP_ADDRESS_KEY,
    USER_DATA_USER_AGENT_KEY,
} from '../../../config/constants';
import { aadharMask } from '../../../lib/utils/validation';

import Swal from 'sweetalert2';
import { userCacheDataService } from '../../../lib/api/userCacheData';
import {
    sessionStorageClearAll,
    sessionStorageGetItem,
    sessionStorageRemoveItem,
    sessionStorageSetItem,
} from '../../../components/storage/sessionStorageManager';
import {
    localStorageGetItem,
    localStorageRemoveItem,
    localStorageSetItem,
} from '../../../components/storage/localStorageManager';
import { useConsentFlow, useKYCDigioSignFlow, useUserProfile } from '../../../hooks/useSelector';
import { InfoIcon, Message } from '../../../lib/constants/messages';
import MaskedInput from 'react-text-mask';
import { getKYCDetails } from '../../../lib/api/digioKYC';
import { subYears } from 'date-fns';
import { useAppDispatch } from '../../../redux/reduxhooks';
import UnsavedChanges from '../../../components/registration/UnsavedChanges';
import { getDefaultCountry } from '../../../hooks/defaultCountryHelper';

type Props = {
    candidateId?: string;
    handleDatAndTab?: (key: string, key2: string) => void;
    selectedAuthType?: string;
    hasUnsavedChanges?: (key: boolean) => void;
    digioSuccessData?: any;
    firstName?: string;
    lastName?: string;
    middleName?: string;
    claimedType?: string;
    phoneNumber?: string;
    country?: string;
    disableFirstAndLastNameField?: boolean;
};

const CandidateSingleRegistrationPage: React.FC<Props> = ({
    digioSuccessData,
    firstName,
    lastName,
    country,
    middleName,
    claimedType = 'company',
    phoneNumber = '',
    disableFirstAndLastNameField = false,
}) => {

    const dispatch = useAppDispatch();
    const consentWorkFlowSettings = useConsentFlow();
    const reduxProfile = useUserProfile();
    const [sessionData, setSessionData] = useState<any>();
    const [selectedDate, setSelectedDate] = useState<any>();
    const [sessionDataStep3, setSessionDataStep3] = useState<any>();
    const [experienceLevelValue, SetExperienceLevelValue] = useState('');
    const [candidateId, setCandidateId] = useState<string | null>('');
    const [selectedCountry, setSelectedCountry] = useState<string>('');
    const [selectedState, setSelectedState] = useState<string>('');
    const [selectedCity, setSelectedCity] = useState<string>('');
    const [passString, setPassString] = useState('');
    const [userPhoneCodeError, setUserPhoneCodeError] = useState('');
    const [isStateValueAvailable, setIsStateValueAvailable] = useState(true);
    const [isCityValueAvailable, setIsCityValueAvailable] = useState(true);
    const [stateDisabled, setStateDisabled] = useState(true);
    const [cityDisabled, setCityDisabled] = useState(true);
    const [iso2CountryString, setIso2CountryString] = useState('');
    const [iso2StateString, setIso2StateString] = useState('');
    const [useCacheData, setUseCacheData] = useState<boolean | undefined>();
    const [combinedLengthError, setCombinedLengthError] = useState('');
    const requestIdValue = localStorageGetItem('requestId');
    const customEmail = localStorageGetItem('Email');
    const kycDigioSignFlowSettings = useKYCDigioSignFlow();
    const seoSearchPresent = localStorageGetItem('seosearch', false);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

    const location = useLocation();

    const captchaEnabled = String(isCaptchaEnabled).toLowerCase() === 'true' ? true : false;

    const navigate = useNavigate();

    const initialFormData = {
        FirstName: '',
        MiddleName: '',
        LastName: '',
        Email: '',
        CityDistrict: '',
        state: '',
        country: getDefaultCountry(),
        Dob: null,
        Gender: undefined,
        Phone: '',
        PostalCode: '',
        streetAddress: '',
        flatAddress: '',
        JobTitle: '',
        HighestEducation: '',
        ExperienceLevel: '',
        PrevCompany: '',
        IsCandidateTermsChecked: false,
        recaptcha: '',
        InstitutionName: '',
        GraduationYear: '',
        UserCountryCode: '',
        Aadhar: '',
    };

    const handleDateChange = (date: any) => {
        setSelectedDate(date);
        localStorageSetItem('selectedDate', date.toISOString(), true);
    };

    const storedDateStr = localStorageGetItem('selectedDate', true);
    let storedDate = storedDateStr ? new Date(storedDateStr || selectedDate) : null;

    useEffect(() => {
        const CustomAuthPass = localStorageGetItem('Password')!;

        if (CustomAuthPass) {
            setPassString(CustomAuthPass);
        }

        if (!consentWorkFlowSettings?.settings) dispatch(getConsentWorkflowSettings());

        const storedPhoneCode = sessionStorageGetItem('phoneCode', false)!;
        setSelectedCountry(storedPhoneCode);

        const data2 = sessionStorageGetItem('candidateStep3', false)!;
        delete data2?.recaptcha;

        setSessionDataStep3(data2);
        SetExperienceLevelValue(data2?.ExperienceLevel === 1 ? 'Experienced' : 'Fresher');

        const inviteId = sessionStorageGetItem('invitationId', false)!;
        setCandidateId(inviteId);
    }, []);

    const storeFormValuesInLocalStorage = (values: any) => {
        setHasUnsavedChanges?.(true);
        let previousValues = secureLocalStorage.getItem(USER_DATA_CACHE_KEY) || {};
        secureLocalStorage.setItem(USER_DATA_CACHE_KEY, {
            ...(previousValues as any),
            ...values,
        });
    };

    const sessionFormData = useMemo(() => {

        const baseCountry = claimedType === 'candidate' 
        ? country 
        : sessionData?.country || getDefaultCountry();

        if (sessionData) {
            if (!sessionData?.ExperienceLevel) {
                SetExperienceLevelValue('');
            }
            SetExperienceLevelValue(Number(sessionData?.ExperienceLevel) === 1 ? 'Experienced' : 'Fresher');
            setSelectedCountry(sessionData?.UserCountryCode);
            // const storedDateStr = sessionData?.Dob;
            // setSelectedDate(storedDateStr);

            if (!sessionData?.cityDistrict) {
                setCityDisabled(true);
            }
            if (!sessionData?.state) {
                setStateDisabled(true);
            }
        }

        return sessionData?.FirstName ||
            sessionData?.firstName ||
            (claimedType === 'candidate' && location.pathname === routes.candClaimRoute)
            ? {
                ...initialFormData,
                FirstName:
                    claimedType === 'candidate' ? firstName : sessionData?.FirstName || reduxProfile?.firstName || '',
                MiddleName: claimedType === 'candidate' ? middleName : sessionData?.MiddleName || '',
                LastName:
                    claimedType === 'candidate' ? lastName : sessionData?.LastName || reduxProfile?.lastName || '',
                Email: sessionData?.Email || customEmail || '',
                Phone: claimedType === 'candidate' ? phoneNumber : sessionData?.Phone || '',
                UserCountryCode: sessionData?.UserCountryCode,
                flatAddress: '',
                streetAddress: '',
                Aadhar: sessionData?.Aadhar,
                country: baseCountry,
                state: sessionData?.state || '',
                CityDistrict: sessionData?.CityDistrict || '',
                Dob: sessionData?.Dob || selectedDate || storedDate || '',
                Gender: isNaN(+sessionData?.Gender) ? undefined : +sessionData?.Gender,

                PostalCode: sessionData?.PostalCode || '',
                JobTitle: sessionData?.JobTitle || '',
                HighestEducation: isNaN(Number(sessionData?.HighestEducation))
                    ? ''
                    : Number(sessionData?.HighestEducation),
                ExperienceLevel: isNaN(Number(sessionData?.ExperienceLevel))
                    ? ''
                    : Number(sessionData?.ExperienceLevel),
                PrevCompany: sessionData?.PrevCompany || '',
                InstitutionName: sessionData?.InstitutionName || '',
                GraduationYear: sessionData?.GraduationYear || '',
            }
            : reduxProfile
                ? {
                    ...initialFormData,
                    FirstName: reduxProfile.firstName,
                    LastName: reduxProfile.lastName,
                    Email: reduxProfile.email,
                    Dob: selectedDate || storedDate || '',
                    country: getDefaultCountry()
                }
                : initialFormData;
    }, [sessionData, reduxProfile, customEmail, firstName, lastName, middleName, phoneNumber]);

    const sessionFormDataStep3 = useMemo(
        () =>
            sessionDataStep3
                ? {
                    ...sessionData,
                    HighestEducation:
                        sessionDataStep3?.HighestEducation === '' ? '' : Number(sessionDataStep3?.HighestEducation),
                    ExperienceLevel:
                        sessionDataStep3?.ExperienceLevel === '' ? '' : Number(sessionDataStep3?.ExperienceLevel),
                    PrevCompany: sessionDataStep3?.PrevCompany,
                    ...(candidateId && { InvitationId: candidateId }),
                    JobTitle: sessionDataStep3?.JobTitle,
                    ...(candidateId && { InvitationId: candidateId }),
                    IsCandidateTermsChecked: sessionDataStep3?.IsCandidateTermsChecked,
                    recaptcha: sessionDataStep3?.recaptcha,
                    GraduationYear: sessionDataStep3?.GraduationYear,
                    InstitutionName: sessionDataStep3?.InstitutionName,
                }
                : initialFormData,
        [sessionDataStep3, sessionData, candidateId]
    );

    const getValidationSchema = (
        isStateValueAvailable: boolean,
        isCityValueAvailable: boolean,
        captchaEnabled: boolean
    ) => {
        if (
            !isConsentFeatureEnabled(consentWorkFlowSettings) ||
            isKYCDigioSignFeatureEnabled(kycDigioSignFlowSettings)
        ) {
            return objectYup().shape({
                FirstName: stringYup().required('First name is required.'),
                LastName: stringYup().required('Last name is required.'),
                Dob: dateYup()
                    .nullable()
                    .transform((current, orig) => (orig === '' ? null : current))
                    .required('Date of birth is required.'),
                Gender: stringYup().required('Gender is required.'),
                Phone: stringYup()
                    .required('Contact number is required and must be 10 digit number.')
                    .min(10, 'Contact number must be at least 10 digits.'),
                CityDistrict: isCityValueAvailable ? stringYup().required('City is required.') : stringYup(),
                state: isStateValueAvailable ? stringYup().required('State is required.') : stringYup(),
                country: stringYup().required('Country is required.'),
                PostalCode: stringYup().required('Postal / Zip code is required.'),
                Aadhar: stringYup()
                    .required('Aadhaar is required and must be last 4 digits of your Aadhaar number.')
                    .max(19, 'Aadhar number must be at least 4 digits.'),
                // flatAddress: stringYup().required('Flat no. / Building name is required.'),
                // streetAddress: stringYup().required('Street address is required.'),

                // HighestEducation: numYup().required('Highest education is required.'),
                // ExperienceLevel: numYup().required('Work experience is required.'),
                // JobTitle: stringYup().when('ExperienceLevel', {
                //     is: ExperienceLevelEnum.Experienced,
                //     then: stringYup().required('Recent job title is required.'),
                // }),
                // PrevCompany: stringYup().when('ExperienceLevel', {
                //     is: ExperienceLevelEnum.Experienced,
                //     then: stringYup().required('Recent company is required.'),
                // }),
                IsCandidateTermsChecked: booleanYup().oneOf([true], 'Please accept terms and conditions to register.'),
                recaptcha: captchaEnabled
                    ? stringYup().nullable().required('Captcha is required.')
                    : stringYup().nullable(),
                // InstitutionName: stringYup().required('Institution is required.'),
                // GraduationYear: numYup()
                //     .nullable()
                //     .integer()
                //     .label('Graduation Year')
                //     .when('Graduation Year', (foundedYear, schema) => {
                //         if (foundedYear) {
                //             return schema.min(1900, invalidYearAlert).max(new Date().getFullYear(), invalidYearAlert);
                //         }
                //         return schema;
                //     })
                //     .required('Graduation year is required.'),
            });
        } else {
            return objectYup().shape({
                FirstName: stringYup().required('First name is required.'),
                LastName: stringYup().required('Last name is required.'),
                Dob: dateYup()
                    .nullable()
                    .transform((current, orig) => (orig === '' ? null : current))
                    .required('Date of birth is required.'),
                Gender: stringYup().required('Gender is required.'),
                Phone: stringYup()
                    .required('Contact number is required and must be 10 digit number.')
                    .min(10, 'Contact number must be at least 10 digits.'),
                CityDistrict: isCityValueAvailable ? stringYup().required('City is required.') : stringYup(),
                state: isStateValueAvailable ? stringYup().required('State is required.') : stringYup(),
                country: stringYup().required('Country is required.'),
                PostalCode: stringYup().required('Postal / Zip code is required.'),
                // Aadhar: stringYup()
                //     .required('Aadhaar is required and must be last 4 digits of your Aadhaar number.')
                //     .max(19, 'Aadhar number must be at least 4 digits.'),
                // flatAddress: stringYup().required('Flat no. / Building name is required.'),
                // streetAddress: stringYup().required('Street address is required.'),

                // HighestEducation: numYup().required('Highest education is required.'),
                // ExperienceLevel: numYup().required('Work experience is required.'),
                // JobTitle: stringYup().when('ExperienceLevel', {
                //     is: ExperienceLevelEnum.Experienced,
                //     then: stringYup().required('Recent job title is required.'),
                // }),
                // PrevCompany: stringYup().when('ExperienceLevel', {
                //     is: ExperienceLevelEnum.Experienced,
                //     then: stringYup().required('Recent company is required.'),
                // }),
                // IsCandidateTermsChecked: booleanYup().oneOf([true], 'Please accept terms and conditions to register.'),
                recaptcha: captchaEnabled
                    ? stringYup().nullable().required('Captcha is required.')
                    : stringYup().nullable(),
                // InstitutionName: stringYup().required('Institution is required.'),
                // GraduationYear: numYup()
                //     .nullable()
                //     .integer()
                //     .label('Graduation Year')
                //     .when('Graduation Year', (foundedYear, schema) => {
                //         if (foundedYear) {
                //             return schema.min(1900, invalidYearAlert).max(new Date().getFullYear(), invalidYearAlert);
                //         }
                //         return schema;
                //     })
                //     .required('Graduation year is required.'),
            });
        }
    };

    const initialErrors = useInitialErrors(
        sessionFormData,
        getValidationSchema(isStateValueAvailable, isCityValueAvailable, captchaEnabled)
    );

    const submitForm = useCallback(
        async (values: CandidateFormData) => {
            // if (!reduxProfile) return;

            // const candidateAddressValue =
            //     sessionData?.flatAddress +
            //     '%' +
            //     sessionData?.streetAddress +
            //     '%' +
            //     sessionData?.PostalCode;

            if (combinedLengthError.length > 0) return;

            const requestData: CandidateRequestType = {
                ...values,
                Aadhar: (values?.Aadhar && values?.Aadhar.slice(-4)) || '',
                Phone: claimedType === 'candidate' ? phoneNumber || '' : values.Phone,
                Email: customEmail || '',
                CityDistrict: values.CityDistrict === '' ? null : values.CityDistrict,
                country: values.country === '' ? '' : values.country,
                state: values.state === '' ? null : values.state,
                Gender: Number(values.Gender),
                CandidateAddress: '%%' + values.PostalCode,
                Dob: (selectedDate && selectedDate) || (values.Dob as Date),
                AuthType: passString ? SocialEnum.CustomAuth : reduxProfile?.authType!,
                Password: (passString && passString) || '',
                Token: reduxProfile?.token! || '',
                HighestEducation: values.HighestEducation === '' ? null : Number(values.HighestEducation),
                ExperienceLevel: values.ExperienceLevel === '' ? null : Number(values.ExperienceLevel),
                PrevCompany: values.PrevCompany,
                ...(candidateId && { InvitationId: candidateId }),
                FirstName: claimedType === 'candidate' ? firstName || '' : values.FirstName,
                LastName: claimedType === 'candidate' ? lastName || '' : values.LastName,
                MiddleName: claimedType === 'candidate' ? middleName || '' : values.MiddleName,
                kycRequestId: requestIdValue || '',
            };

            try {
                const data = await authService.candidateSignUp(requestData);
                if (data) {
                    dispatch(deleteReduxProfile());
                    localStorageRemoveItem('Password');
                    localStorageRemoveItem('Email');
                    // sessionStorageRemoveItem('user-basic-details');
                    // sessionStorageRemoveItem('firstTimeOpen');
                    setHasUnsavedChanges?.(false);
                    secureLocalStorage.removeItem(USER_DATA_CACHE_KEY);
                    sessionStorageClearAll();

                    if (seoSearchPresent?.url) {
                        if (seoSearchPresent?.isCandidate) {
                            await goToRoom(data, dispatch, navigate, {
                                isCandidate: true,
                                candidateFirstName: seoSearchPresent?.data.firstName,
                                candidateLastName: seoSearchPresent?.data.lastName,
                                hashedId: seoSearchPresent?.data?.hashId,
                            });
                        } else {
                            await goToRoom(data, dispatch, navigate, {
                                isCandidate: false,
                                companyName: seoSearchPresent?.data?.name,
                                hashedId: seoSearchPresent?.data?.hashId,
                            });
                        }
                    } else {
                        await goToRoom(data, dispatch, navigate);
                    }
                }
                localStorageRemoveItem('phoneNumber');
            } catch (err) { }
        },
        [
            combinedLengthError,
            passString,
            reduxProfile?.authType,
            reduxProfile?.token,
            candidateId,
            dispatch,
            setHasUnsavedChanges,
            requestIdValue,
            customEmail,
        ]
    );

    const getCombinedNameError = (values: CandidateFormData) => {
        if (values) {
            const combinedLength =
                (values.FirstName || '').length + (values.MiddleName || '').length + (values.LastName || '').length;
            if (combinedLength > 100) {
                setCombinedLengthError('Candidate name cannot exceed 100 characters.');
            } else {
                setCombinedLengthError('');
            }
        }
    };

    useEffect(() => {
        const convertDate = (inputDate: string) => {
            const [day, month, year] = inputDate.split('/').map(Number);

            const date = new Date(year, month - 1, day); // Month is 0-indexed

            return date.toString();
        };

        if (digioSuccessData) {
            (async () => {
                const response = await getKYCDetails(digioSuccessData.digio_doc_id);
                const { dob, gender, name, idNumber } = response;
                const Gender = gender === 'M' ? GenderEnum.male : GenderEnum.female;
                const match = idNumber.match(/\d{4}$/);
                const Dob = convertDate(dob);
                const formatedDate = new Date(Dob);
                const [FirstName, LastName] = name.split(' ');
                if (match && Dob) {
                    setSessionData({
                        ...sessionData,
                        FirstName,
                        LastName,
                        country: '101',
                        Gender,
                        Aadhar: `XXXX XXXX XXXX ${match[0]}`,
                    });
                    setSelectedDate(formatedDate);
                }
            })();
        }
    }, [digioSuccessData]);

    useEffect(() => {
    if (ALLOWED_COUNTRIES.length === 1 && !sessionData?.country) {
        // Auto-select the single allowed country
        const defaultCountry = ALLOWED_COUNTRIES[0];
        setSelectedCountry(defaultCountry);
        setStateDisabled(false); // Enable state dropdown
        
        // Store in local storage
        storeFormValuesInLocalStorage({
            country: defaultCountry,
        });
    }
}, []);

    return (
        <>
            <UnsavedChanges
                customEmail={customEmail}
                hasUnsavedChanges={hasUnsavedChanges}
                reduxProfile={reduxProfile}
                sessionData={sessionData}
                setIso2CountryString={setIso2CountryString}
                setSessionData={setSessionData}
                setUseCacheData={setUseCacheData}
            />
            <Formik
                onSubmit={submitForm}
                enableReinitialize
                initialValues={sessionFormData as any}
                validationSchema={getValidationSchema(isStateValueAvailable, isCityValueAvailable, captchaEnabled)}
                initialErrors={initialErrors}
            >
                {(formikProps: FormikProps<CandidateFormData>) => {
                    const { handleSubmit, values, isSubmitting, setFieldTouched, setFieldValue } = formikProps;
                    const siteKey = getSiteKey();

                    return (
                        <form onSubmit={handleSubmit}>
                            <div className="card lt-shadow-sm">
                                <div className="card-body">
                                    <div className="container-fluid">
                                        <div className="fs-20 fw-600 lt-text-secondary">Welcome to OfferX!</div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="reg-scroll-ht">
                                        {/* 1. Candidate details */}
                                        <div className="mb-3">
                                            <div className="container-fluid">
                                                {isKYCDigioSignFeatureEnabled(kycDigioSignFlowSettings) && (
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="fs-18 fw-600 mb-3">
                                                                Identification Details
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="mb-4">
                                                                <label className="fs-14 fw-400 mb-2">
                                                                    Aadhaar number{' '}
                                                                    <span className="lt-text-error">*</span>
                                                                </label>
                                                                <Field name="Aadhar">
                                                                    {(fieldProps: FieldProps) => {
                                                                        const { field, form } = fieldProps;
                                                                        const error =
                                                                            getValue(form.touched, field.name) &&
                                                                            getValue(form.errors, field.name);
                                                                        return (
                                                                            <>
                                                                                <MaskedInput
                                                                                    value={field.value}
                                                                                    disabled={
                                                                                        sessionData?.Aadhar &&
                                                                                        !useCacheData
                                                                                    }
                                                                                    onChange={(ev) => {
                                                                                        setFieldTouched(field.name);
                                                                                        setFieldValue(
                                                                                            field.name,
                                                                                            ev.target.value
                                                                                        );
                                                                                    }}
                                                                                    className={`form-control ${error ? 'is-invalid' : ''
                                                                                        }`}
                                                                                    placeholder="Last 4 Digits of your aadhaar"
                                                                                    guide={false}
                                                                                    mask={aadharMask}
                                                                                />
                                                                                {typeof error === 'string' && (
                                                                                    <small className="text-danger fs-12">
                                                                                        {error}
                                                                                    </small>
                                                                                )}
                                                                            </>
                                                                        );
                                                                    }}
                                                                </Field>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="fs-18 fw-600 mb-3">Candidate Details</div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="mb-4">
                                                            <label className="fs-14 fw-400 mb-2" htmlFor="fname">
                                                                First Name <span className="lt-text-error">*</span>
                                                            </label>
                                                            <Field name="FirstName">
                                                                {(fieldProps: FieldProps) => {
                                                                    const { field, form } = fieldProps;
                                                                    const error =
                                                                        getValue(form.touched, field.name) &&
                                                                        getValue(form.errors, field.name);

                                                                    if (
                                                                        values.FirstName &&
                                                                        values.FirstName.length > 0
                                                                    ) {
                                                                        getCombinedNameError(values);
                                                                    }
                                                                    return (
                                                                        <>
                                                                            <input
                                                                                type="text"
                                                                                value={field.value}
                                                                                disabled={
                                                                                    (sessionData?.FirstName &&
                                                                                        !useCacheData) ||
                                                                                    claimedType === 'candidate' ||
                                                                                    disableFirstAndLastNameField
                                                                                }
                                                                                onChange={(ev) => {
                                                                                    const regex = /^[a-zA-Z0-9 ]*$/;
                                                                                    if (disableFirstAndLastNameField) {
                                                                                        return;
                                                                                    }

                                                                                    if (regex.test(ev.target.value)) {
                                                                                        setFieldTouched(field.name);
                                                                                        setFieldValue(
                                                                                            field.name,
                                                                                            ev.target.value
                                                                                        );
                                                                                        storeFormValuesInLocalStorage({
                                                                                            ...values,
                                                                                            FirstName: ev.target.value,
                                                                                        });
                                                                                    }
                                                                                }}
                                                                                className={`form-control ${error ? 'is-invalid' : ''
                                                                                    }`}
                                                                                placeholder={
                                                                                    'As on your Highest Educational Certificate'
                                                                                }
                                                                                maxLength={100}
                                                                                id="fname"
                                                                            />
                                                                            {typeof error === 'string' && (
                                                                                <small className="text-danger fs-12">
                                                                                    {error}
                                                                                </small>
                                                                            )}
                                                                        </>
                                                                    );
                                                                }}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="mb-4">
                                                            <label className="fs-14 fw-400 mb-2" htmlFor="mname">
                                                                Middle Name
                                                            </label>
                                                            <Field name="MiddleName">
                                                                {(fieldProps: FieldProps) => {
                                                                    const { field } = fieldProps;
                                                                    if (
                                                                        values.MiddleName &&
                                                                        values.MiddleName.length > 0
                                                                    ) {
                                                                        getCombinedNameError(values);
                                                                    }
                                                                    return (
                                                                        <>
                                                                            <input
                                                                                type="text"
                                                                                value={field.value}
                                                                                disabled={
                                                                                    claimedType === 'candidate' ||
                                                                                    disableFirstAndLastNameField
                                                                                }
                                                                                onChange={(ev) => {
                                                                                    const regex = /^[a-zA-Z0-9 ]*$/;

                                                                                    if (disableFirstAndLastNameField) {
                                                                                        return;
                                                                                    }

                                                                                    if (regex.test(ev.target.value)) {
                                                                                        setFieldTouched(field.name);
                                                                                        setFieldValue(
                                                                                            field.name,
                                                                                            ev.target.value
                                                                                        );
                                                                                        storeFormValuesInLocalStorage({
                                                                                            ...values,
                                                                                            MiddleName: ev.target.value,
                                                                                        });
                                                                                    }
                                                                                }}
                                                                                className="form-control"
                                                                                placeholder={
                                                                                    'As on your Highest Educational Certificate'
                                                                                }
                                                                                maxLength={100}
                                                                                id="mname"
                                                                            />
                                                                        </>
                                                                    );
                                                                }}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="mb-4">
                                                            <label className="fs-14 fw-400 mb-2" htmlFor="lname">
                                                                Last Name <span className="lt-text-error">*</span>
                                                            </label>
                                                            <Field name="LastName">
                                                                {(fieldProps: FieldProps) => {
                                                                    const { field, form } = fieldProps;
                                                                    const error =
                                                                        getValue(form.touched, field.name) &&
                                                                        getValue(form.errors, field.name);

                                                                    if (values.LastName && values.LastName.length > 0) {
                                                                        getCombinedNameError(values);
                                                                    }
                                                                    return (
                                                                        <>
                                                                            <input
                                                                                type="text"
                                                                                value={field.value}
                                                                                disabled={
                                                                                    (sessionData?.LastName &&
                                                                                        !useCacheData) ||
                                                                                    claimedType === 'candidate' ||
                                                                                    disableFirstAndLastNameField
                                                                                }
                                                                                onChange={(ev) => {
                                                                                    const regex = /^[a-zA-Z0-9 ]*$/;

                                                                                    if (disableFirstAndLastNameField) {
                                                                                        return;
                                                                                    }

                                                                                    if (regex.test(ev.target.value)) {
                                                                                        setFieldTouched(field.name);
                                                                                        setFieldValue(
                                                                                            field.name,
                                                                                            ev.target.value
                                                                                        );
                                                                                        storeFormValuesInLocalStorage({
                                                                                            ...values,
                                                                                            LastName: ev.target.value,
                                                                                        });
                                                                                    }
                                                                                }}
                                                                                className={`form-control ${error ? 'is-invalid' : ''
                                                                                    }`}
                                                                                placeholder={
                                                                                    'As on your Highest Educational Certificate'
                                                                                }
                                                                                maxLength={100}
                                                                                id="lname"
                                                                            />
                                                                            {/* <small className="text-danger fs-12">{error}</small> */}
                                                                            {combinedLengthError ? (
                                                                                <small className="text-danger fs-12">
                                                                                    {combinedLengthError}
                                                                                </small>
                                                                            ) : (
                                                                                typeof error === 'string' && (
                                                                                    <small className="text-danger fs-12">
                                                                                        {error}
                                                                                    </small>
                                                                                )
                                                                            )}
                                                                        </>
                                                                    );
                                                                }}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="mb-4">
                                                            <label
                                                                className="fs-14 fw-400 mb-2"
                                                                htmlFor="DataRangeText"
                                                            >
                                                                Date of Birth <span className="lt-text-error">*</span>
                                                            </label>
                                                            <Field name="Dob">
                                                                {(fieldProps: FieldProps) => {
                                                                    const { field, form } = fieldProps;
                                                                    const error =
                                                                        getValue(form.touched, field.name) &&
                                                                        getValue(form.errors, field.name);

                                                                    return (
                                                                        <>
                                                                            <div
                                                                                className={
                                                                                    error
                                                                                        ? 'react-datepicker-error'
                                                                                        : ''
                                                                                }
                                                                            >
                                                                                <DatePickerComponent
                                                                                    key={
                                                                                        (field?.value as any) ||
                                                                                        selectedDate
                                                                                    }
                                                                                    onChange={(date) => {
                                                                                        handleDateChange(date);
                                                                                        setFieldTouched(field.name);
                                                                                        setFieldValue(field.name, date);
                                                                                        storeFormValuesInLocalStorage({
                                                                                            ...values,
                                                                                            Dob: (
                                                                                                date as any
                                                                                            ).toISOString(),
                                                                                        });
                                                                                    }}
                                                                                    headerSelects
                                                                                    startDate={
                                                                                        (field?.value as Date) ||
                                                                                        storedDate
                                                                                    }
                                                                                    // minDate={moment()
                                                                                    //     .subtract(65, 'years')
                                                                                    //     .toDate()}
                                                                                    // maxDate={moment()
                                                                                    //     .subtract(18, 'years')
                                                                                    //     .toDate()}
                                                                                    minDate={subYears(new Date(), 65)}
                                                                                    maxDate={subYears(new Date(), 18)}
                                                                                    placeholder="As on your Highest Educational Certificate"
                                                                                />
                                                                            </div>
                                                                            {typeof error === 'string' && (
                                                                                <small className="text-danger fs-12">
                                                                                    {error}
                                                                                </small>
                                                                            )}
                                                                        </>
                                                                    );
                                                                }}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="mb-4">
                                                            <label className="fs-14 fw-400 mb-2">
                                                                Gender <span className="lt-text-error">*</span>
                                                            </label>
                                                            <Field name="Gender">
                                                                {(fieldProps: FieldProps) => {
                                                                    const { field, form } = fieldProps;
                                                                    const error =
                                                                        getValue(form.touched, field.name) &&
                                                                        getValue(form.errors, field.name);
                                                                    return (
                                                                        <>
                                                                            <select
                                                                                value={field.value}
                                                                                // disabled={
                                                                                //     sessionData?.Gender ===
                                                                                //         GenderEnum.male ||
                                                                                //     sessionData?.Gender ===
                                                                                //         GenderEnum.female
                                                                                //         ? true
                                                                                //         : false
                                                                                // }
                                                                                onChange={(ev) => {
                                                                                    setFieldTouched(field.name);
                                                                                    setFieldValue(
                                                                                        field.name,
                                                                                        ev.target.value
                                                                                    );
                                                                                    storeFormValuesInLocalStorage({
                                                                                        ...values,
                                                                                        Gender: ev.target.value,
                                                                                        GenderName:
                                                                                            ev.target
                                                                                                ?.selectedOptions[0]
                                                                                                ?.innerText,
                                                                                    });
                                                                                }}
                                                                                className={`form-select ${error ? 'is-invalid' : ''
                                                                                    }`}
                                                                            >
                                                                                <option value="">
                                                                                    Select Your Gender
                                                                                </option>
                                                                                <option value={GenderEnum.male}>
                                                                                    Male
                                                                                </option>
                                                                                <option value={GenderEnum.female}>
                                                                                    Female
                                                                                </option>
                                                                                <option
                                                                                    value={
                                                                                        GenderEnum.preferNotToDisclose
                                                                                    }
                                                                                >
                                                                                    Prefer Not To Disclose
                                                                                </option>
                                                                            </select>
                                                                            {typeof error === 'string' && (
                                                                                <small className="text-danger fs-12">
                                                                                    {error}
                                                                                </small>
                                                                            )}
                                                                        </>
                                                                    );
                                                                }}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="mb-4">
                                                            <label className="fs-14 fw-400 mb-2" htmlFor="contact">
                                                                Contact Number <span className="lt-text-error">*</span>
                                                            </label>
                                                            <div className="d-flex">
                                                                <Field name="UserCountryCode">
                                                                    {(fieldProps: FieldProps) => {
                                                                        const { field, form } = fieldProps;
                                                                        const error =
                                                                            getValue(form.touched, field.name) &&
                                                                            getValue(form.errors, field.name);
                                                                        return (
                                                                            <>
                                                                                <div className="">
                                                                                    <PhoneCodeDropdown
                                                                                        id="candidate"
                                                                                        candidateValue={field.value}
                                                                                        setFieldValue={setFieldValue}
                                                                                        onPhoneCodeSelectionChange={(
                                                                                            code: any
                                                                                        ) => {
                                                                                            storeFormValuesInLocalStorage(
                                                                                                {
                                                                                                    ...values,
                                                                                                    UserCountryCode:
                                                                                                        code,
                                                                                                }
                                                                                            );
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </>
                                                                        );
                                                                    }}
                                                                </Field>
                                                                <Field name="Phone">
                                                                    {(fieldProps: FieldProps) => {
                                                                        const { field, form } = fieldProps;
                                                                        const error =
                                                                            getValue(form.touched, field.name) &&
                                                                            getValue(form.errors, field.name);

                                                                        if (error) {
                                                                            setUserPhoneCodeError(error.toString());
                                                                        } else {
                                                                            setUserPhoneCodeError('');
                                                                        }
                                                                        return (
                                                                            <>
                                                                                <input
                                                                                    type="text"
                                                                                    value={field.value}
                                                                                    onChange={(ev) => {
                                                                                        const regex = /^\d+$/;

                                                                                        if (
                                                                                            disableFirstAndLastNameField &&
                                                                                            claimedType ===
                                                                                            'candidate' &&
                                                                                            field.value.length >= 10
                                                                                        ) {
                                                                                            return;
                                                                                        }

                                                                                        if (
                                                                                            regex.test(ev.target.value)
                                                                                        ) {
                                                                                            setFieldTouched(field.name);
                                                                                            setFieldValue(
                                                                                                field.name,
                                                                                                ev.target.value
                                                                                            );
                                                                                            storeFormValuesInLocalStorage(
                                                                                                {
                                                                                                    ...values,
                                                                                                    Phone: ev.target
                                                                                                        .value,
                                                                                                }
                                                                                            );
                                                                                        } else if (
                                                                                            ev.target.value === ''
                                                                                        ) {
                                                                                            setFieldValue(
                                                                                                field.name,
                                                                                                ''
                                                                                            );
                                                                                        }
                                                                                    }}
                                                                                    className={`form-control form-phone-border ${error
                                                                                            ? 'phone-input is-invalid'
                                                                                            : ''
                                                                                        }`}
                                                                                    disabled={(sessionData?.Phone &&
                                                                                        !useCacheData) ||
                                                                                        claimedType === 'candidate' &&
                                                                                        field.value.length >= 10}
                                                                                    placeholder="Enter Contact Number"
                                                                                    maxLength={10}
                                                                                    id="contact"
                                                                                />
                                                                                {/* <small className="text-danger fs-12">{error}</small> */}
                                                                            </>
                                                                        );
                                                                    }}
                                                                </Field>
                                                            </div>
                                                            <small className="text-danger fs-12">
                                                                {userPhoneCodeError}
                                                            </small>
                                                        </div>
                                                    </div>
                                                    {/* <div className="col-md-6">
                                                <div className="mb-4">
                                                    <label className="fs-14 fw-400 mb-2">Login Email</label>
                                                    <Field name="Email">
                                                        {(fieldProps: FieldProps) => {
                                                            const { field, form } = fieldProps;
                                                            const error =
                                                                getValue(form.touched, field.name) &&
                                                                getValue(form.errors, field.name);

                                                            return (
                                                                <>
                                                                    <input
                                                                        type="email"
                                                                        disabled
                                                                        value={field.value}

                                                                        className={`form-control ${error ? 'is-invalid' : ''
                                                                            }`}
                                                                        placeholder="Enter your email"
                                                                        maxLength={100}
                                                                    />
                                                                    <small className="text-danger fs-12">{error}</small>
                                                                </>
                                                            );
                                                        }}
                                                    </Field>
                                                </div>
                                            </div> */}
                                                </div>
                                            </div>
                                        </div>

                                        {/* 2. Location details */}
                                        <div className="mb-3">
                                            <div className="container-fluid">
                                                <div className="row mt-3">
                                                    <div className="col-12">
                                                        <div className="fs-18 fw-600 mb-3">Location Details</div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="mb-4">
                                                            <label className="fs-14 fw-400 mb-2">
                                                                Country <span className="lt-text-error">*</span>
                                                            </label>
                                                            <Field name="country">
                                                                {(fieldProps: FieldProps) => {
                                                                    const { field, form } = fieldProps;
                                                                    const error =
                                                                        getValue(form.touched, field.name) &&
                                                                        getValue(form.errors, field.name);

                                                                    return (
                                                                        <>
                                                                            <CountryDropdown
                                                                                id="country"
                                                                                setFieldValue={setFieldValue}
                                                                                countryFieldValue={field.value}
                                                                                setStateDisabled={setStateDisabled}
                                                                                setCityDisabled={setCityDisabled}
                                                                                setIso2CountryString={
                                                                                    setIso2CountryString
                                                                                }
                                                                                error={field.value === '' ? error : ''}
                                                                                allowedCountries={ALLOWED_COUNTRIES}
                                                                                onCountrySelectionChange={(
                                                                                    country: any
                                                                                ) => {
                                                                                    storeFormValuesInLocalStorage({
                                                                                        ...values,
                                                                                        country: country.id.toString(),
                                                                                        CountryName: country.name,
                                                                                    });
                                                                                }}
                                                                            />
                                                                            {typeof error === 'string' && (
                                                                                <small className="text-danger fs-12">
                                                                                    {' '}
                                                                                    {field.value === '' ? error : ''}
                                                                                </small>
                                                                            )}
                                                                        </>
                                                                    );
                                                                }}
                                                            </Field>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <div className="mb-4">
                                                            <label className="fs-14 fw-400 mb-2">
                                                                State <span className="lt-text-error">*</span>
                                                            </label>
                                                            <Field name="state">
                                                                {(fieldProps: FieldProps) => {
                                                                    const { field, form } = fieldProps;
                                                                    const error =
                                                                        getValue(form.touched, field.name) &&
                                                                        getValue(form.errors, field.name);

                                                                    return (
                                                                        <>
                                                                            <StateDropdown
                                                                                id="state"
                                                                                key={selectedState}
                                                                                setFieldValue={setFieldValue}
                                                                                setIsStateValueAvailable={
                                                                                    setIsStateValueAvailable
                                                                                }
                                                                                setIsCityValueAvailable={
                                                                                    setIsCityValueAvailable
                                                                                }
                                                                                setStateDisabled={setStateDisabled}
                                                                                stateFieldValue={
                                                                                    field.value || selectedState
                                                                                }
                                                                                stateDisabled={stateDisabled}
                                                                                setCityDisabled={setCityDisabled}
                                                                                Iso2CountryString={iso2CountryString}
                                                                                setIso2StateString={setIso2StateString}
                                                                                error={
                                                                                    isStateValueAvailable &&
                                                                                        field.value === ''
                                                                                        ? error
                                                                                        : ''
                                                                                }
                                                                                onStateSelectionChange={(
                                                                                    state: any
                                                                                ) => {
                                                                                    storeFormValuesInLocalStorage({
                                                                                        ...values,
                                                                                        state: state.id.toString(),
                                                                                        StateName: state.name,
                                                                                    });
                                                                                }}
                                                                            />

                                                                            {typeof error === 'string' && (
                                                                                <small className="text-danger fs-12">
                                                                                    {isStateValueAvailable &&
                                                                                        field.value === ''
                                                                                        ? error
                                                                                        : ''}
                                                                                </small>
                                                                            )}
                                                                        </>
                                                                    );
                                                                }}
                                                            </Field>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <div className="mb-4">
                                                            <label className="fs-14 fw-400 mb-2">
                                                                City <span className="lt-text-error">*</span>
                                                            </label>
                                                            <Field name="CityDistrict">
                                                                {(fieldProps: FieldProps) => {
                                                                    const { field, form } = fieldProps;
                                                                    const error =
                                                                        getValue(form.touched, field.name) &&
                                                                        getValue(form.errors, field.name);
                                                                    return (
                                                                        <>
                                                                            <CityDropdown
                                                                                id="city"
                                                                                setFieldValue={setFieldValue}
                                                                                setIsCityValueAvailable={
                                                                                    setIsCityValueAvailable
                                                                                }
                                                                                setCityDisabled={setCityDisabled}
                                                                                cityFieldValue={
                                                                                    field.value || selectedCity
                                                                                }
                                                                                cityDisabled={cityDisabled}
                                                                                iso2CountryString={iso2CountryString}
                                                                                iso2StateString={iso2StateString}
                                                                                error={
                                                                                    isCityValueAvailable &&
                                                                                        field.value === ''
                                                                                        ? error
                                                                                        : ''
                                                                                }
                                                                                onCitySelectionChange={(city: any) => {
                                                                                    storeFormValuesInLocalStorage({
                                                                                        ...values,
                                                                                        CityDistrict:
                                                                                            city.id.toString(),
                                                                                        CityName: city.name,
                                                                                    });
                                                                                }}
                                                                            />
                                                                            {typeof error === 'string' && (
                                                                                <small className="text-danger fs-12">
                                                                                    {isCityValueAvailable &&
                                                                                        field.value === ''
                                                                                        ? error
                                                                                        : ''}
                                                                                </small>
                                                                            )}
                                                                        </>
                                                                    );
                                                                }}
                                                            </Field>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <div className="mb-4">
                                                            <label className="fs-14 fw-400 mb-2" htmlFor="zip">
                                                                Postal / Zip Code{' '}
                                                                <span className="lt-text-error">*</span>
                                                            </label>
                                                            <Field name="PostalCode">
                                                                {(fieldProps: FieldProps) => {
                                                                    const { field, form } = fieldProps;
                                                                    const error =
                                                                        getValue(form.touched, field.name) &&
                                                                        getValue(form.errors, field.name);
                                                                    return (
                                                                        <>
                                                                            <input
                                                                                type="text"
                                                                                value={field.value}
                                                                                onChange={(ev) => {
                                                                                    setFieldTouched(field.name);
                                                                                    setFieldValue(
                                                                                        field.name,
                                                                                        ev.target.value
                                                                                    );
                                                                                    storeFormValuesInLocalStorage({
                                                                                        ...values,
                                                                                        PostalCode: ev.target.value,
                                                                                    });
                                                                                }}
                                                                                className={`form-control ${error ? 'is-invalid' : ''
                                                                                    }`}
                                                                                placeholder="Enter Postal / Zip Code"
                                                                                maxLength={10}
                                                                                id="zip"
                                                                            />
                                                                            {typeof error === 'string' && (
                                                                                <small className="text-danger fs-12">
                                                                                    {error}
                                                                                </small>
                                                                            )}
                                                                        </>
                                                                    );
                                                                }}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* 3. Education details */}
                                        <div className=" mb-0">
                                            <div className="container-fluid">
                                                <div className="row mt-3">
                                                    {!isConsentFeatureEnabled(consentWorkFlowSettings) && (
                                                        <div className="col-md-12">
                                                            <div className="mb-3">
                                                                <div className="form-check mb-2 custom-h-40">
                                                                    <Field
                                                                        className="form-check-input cursor-pointer"
                                                                        name="IsCandidateTermsChecked"
                                                                        type="checkbox"
                                                                        id="check"
                                                                        checked={values.IsCandidateTermsChecked}
                                                                    ></Field>
                                                                    <label
                                                                        className="form-check-label fs-13 mt-1 cursor-pointer lt-text-secondary"
                                                                        htmlFor="check"
                                                                    >
                                                                        I have read and agree to the{' '}
                                                                        <Link to={routes.privacy} target="_blank">
                                                                            Privacy Policy
                                                                        </Link>{' '}
                                                                        and{' '}
                                                                        <Link to={routes.terms} target="_blank">
                                                                            Terms & Conditions
                                                                        </Link>
                                                                        .
                                                                    </label>
                                                                    <Field name="IsCandidateTermsChecked">
                                                                        {(fieldProps: FieldProps) => {
                                                                            const { field, form } = fieldProps;
                                                                            const error =
                                                                                getValue(form.touched, field.name) &&
                                                                                getValue(form.errors, field.name);
                                                                            return (
                                                                                <div>
                                                                                    {typeof error === 'string' && (
                                                                                        <small className="text-danger fs-12">
                                                                                            {error}
                                                                                        </small>
                                                                                    )}
                                                                                </div>
                                                                            );
                                                                        }}
                                                                    </Field>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {captchaEnabled && (
                                                        <div className="col-md-12">
                                                            <div className="mb-4">
                                                                <Field name="recaptcha">
                                                                    {(fieldProps: FieldProps) => {
                                                                        const { field, form } = fieldProps;
                                                                        const error =
                                                                            getValue(form.touched, field.name) &&
                                                                            getValue(form.errors, field.name);
                                                                        return (
                                                                            <div>
                                                                                <ReCAPTCHA
                                                                                    sitekey={siteKey}
                                                                                    onChange={(value) => {
                                                                                        setFieldTouched(field.name);
                                                                                        setFieldValue(
                                                                                            field.name,
                                                                                            value
                                                                                        );
                                                                                    }}
                                                                                />
                                                                                {typeof error === 'string' && (
                                                                                    <small className="text-danger fs-12">
                                                                                        {error}
                                                                                    </small>
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    }}
                                                                </Field>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <div className=" d-flex flex-row-reverse card-body">
                                            <button
                                                type="submit"
                                                disabled={isSubmitting}
                                                className="btn btn-primary social-next-button"
                                                onClick={() => {
                                                    if (selectedDate) {
                                                        setFieldValue('Dob', selectedDate);
                                                    }
                                                }}
                                            >
                                                {isSubmitting && <span className="spinner-border spinner-border-sm" />}
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </>
    );
};

export default CandidateSingleRegistrationPage;
